export function formatExpeditionName(name: string | undefined | null): string {
  // Return a default title if the name is not a string or is empty
  if (typeof name !== 'string' || !name) {
    return 'Expedition Details';
  }

  // Check if the name matches the pattern YYYY_EXPEDITION_N
  const expeditionPattern = /^(\d{4})_EXPEDITION_(\d+)$/;
  const match = name.match(expeditionPattern);
  if (match) {
    const [, year, number] = match;
    return `${year} Expedition ${number}`;
  }

  const prefix = "Expedition";
  // Check if it starts with "Expedition" and the next char isn't a space
  if (name.startsWith(prefix) && name.length > prefix.length && name[prefix.length] !== ' ') {
    // Insert space
    return `${prefix} ${name.substring(prefix.length)}`;
  }
  // Otherwise, return the original name
  return name;
}
